import React, { useState } from "react";
import styles from "./Input.module.scss";
import eyeOpenImage from "../../assets/images/ic_visibility.svg";
import eyeClosedImage from "../../assets/images/ic_visibility_off.svg";

export type InputType = "text" | "date" | "password" | "email";
// https://developers.google.com/web/fundamentals/design-and-ux/input/forms
export type AutoCompleteType = "family-name" | "email" | "current-password" | "new-password" | "username" | "";
type PasswordState = "hide" | "show";

interface InputState {
  definedInputType: InputType;
  autoCompleteType: AutoCompleteType;
  inputType: InputType;
  passwordState: PasswordState;
  passwordImage: any;
}

function createInitialInputState(definedInputType?: InputType, definedAutoCompleteType?: AutoCompleteType): InputState {
  if (!definedInputType) {
    definedInputType = "text";
  }
  if (!definedAutoCompleteType) {
    definedAutoCompleteType = "";
  }
  return {
    definedInputType,
    inputType: definedInputType,
    passwordState: "hide",
    passwordImage: eyeOpenImage,
    autoCompleteType: definedAutoCompleteType
  };
}

export interface InputProps {
  name: string;
  value: string;
  showErrorBorder: boolean;
  inputType?: InputType;
  autoCompleteType?: AutoCompleteType;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  readonly?: boolean;
}

export const Input = (props: InputProps) => {
  const [inputState, setInputState] = useState<InputState>(
    createInitialInputState(props.inputType, props.autoCompleteType)
  );

  const onPasswordClick = () => {
    if (inputState.definedInputType === "password") {
      const newPasswordState = inputState.passwordState === "show" ? "hide" : "show";
      const newPasswordImage = newPasswordState === "show" ? eyeClosedImage : eyeOpenImage;
      const newInputType: InputType = newPasswordState === "show" ? "text" : "password";
      const newInputState: InputState = {
        definedInputType: inputState.definedInputType,
        autoCompleteType: inputState.autoCompleteType,
        passwordState: newPasswordState,
        passwordImage: newPasswordImage,
        inputType: newInputType
      };
      setInputState(newInputState);
    }
  };

  return (
    <div className={styles.outer_container}>
      <input
        className={props.showErrorBorder ? styles.input_errored : styles.input}
        type={inputState.inputType}
        autoComplete={inputState.autoCompleteType}
        id={props.name}
        name={props.name}
        data-name={props.name}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        readOnly={props.readonly}
      />
      {inputState.definedInputType === "password" && (
        <button onClick={onPasswordClick} className={styles.lock_image_button}>
          <img className={styles.lock_image} src={inputState.passwordImage} alt="Show or hide password" />
        </button>
      )}
    </div>
  );
};
